import React from 'react';

export function TextField({ label, type = "text", ...props }) {
  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}
      <input type={type} {...props} />
    </div>
  )
}

export function TextAreaField({ label, ...props }) {
  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}
      <textarea {...props} />
    </div>
  );
}

export function Select({ label, options, ...props }) {
  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}
      <select {...props}>
        <option value="">Please select...</option>
        {options.map(([value, option_label]) => (
          <option key={value} value={value}>{option_label}</option>
        ))}
      </select>
    </div>
  );
}
